export default {
    data() {
        return {
            index: 0,
            message: '',
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            personageMessage: '',
            isPersonageMessage: false,
            users: {
                name: '',
                company: '',
                email: '',
                idcard: '',
                // code: '',
				phone:'',
				gender:''
            },
			// 公司所属地区
			companyTerritory: [
				'郑州市', '开封市', '洛阳市', '平顶山市', '安阳市', '鹤壁市', '新乡市', '焦作市', '济源市', '濮阳市', '许昌市', '漯河市', '三门峡市', '南阳市', '商丘市', '信阳市',
				'周口市', '驻马店市'
			],
			//性别
			gender:['男','女']
        }
    },
    methods: {
        //旧密码框获取焦点
        OldPasswordFocus: function () {
            if (this.personageMessage === '旧密码不能为空' || this.personageMessage === '旧密码不正确') {
                this.isPersonageMessage = false;
            }
        },
        //密码框获取焦点
        PasswordFocus: function () {
            if (this.personageMessage === '密码不能为空' || this.personageMessage === '两次密码不匹配') {
                this.isPersonageMessage = false;
            }
        },
        //确认密码框获取焦点
        AffirmPasswordFocus: function () {
            if (this.personageMessage === '确认密码不能为空' || this.personageMessage === '两次密码不匹配') {
                this.isPersonageMessage = false;
            }
        },

        getusers: function () {
            this.$post('users/profile', {
                token: this.$store.state.id
            }).then(res => {
                this.users = res.data.result
                this.users.name ? document.querySelector('#name').setAttribute("disabled", "disabled") : this.users.name;
            })
        },
        //邮箱校验
        checkEmail() {
            if (this.users.email != '') {
                let emsreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                if (!emsreg.test(this.users.email)) {
                    // console.log('邮箱格式错误')
                } else {
                    // savePersonal()
                }
            } else {
                // savePersonal()
            }
        },
        //更新方法
        update() {
            this.$post('users/edit', {
                token: this.$store.state.id,
                name: this.users.name,
                email: this.users.email,
                phone: this.users.phone,
                company: this.users.company,
                // idcard: this.users.idcard,
                // code: this.users.code,
                gender: this.users.gender,
                city: this.users.city,
            }).then(res => {
                if (res.data.status === 'fail') {
                    this.message = '修改失败';
                    let model = document.querySelector('#modal-close-default-two');
                    UIkit.modal(model).show();
                    // this.$message.error('修改失败');
                } else {
                    // this.$post('users/save_member', {
                    //     token: this.$store.state.id,
                    //     name: this.users.name,
                    //     email: this.users.email,
                    //     company: this.users.company,
                    //     code: this.users.code,
                    //     memberId:this.$store.state.oldUserData.memberId
                    // }).then(res=>{
                        
                    // })
                    // this.$message.success('修改成功');
                    this.message = '修改成功';
                    this.$store.state.name = this.users.name;
                    let model = document.querySelector('#modal-close-default-two');
                    UIkit.modal(model).show();
                    this.getusers();
                }
            })
        },
        // savePersonal() {
        //     // console.log(this.checkEmail());
        //     this.$post('users/profile', {
        //         token: this.$store.state.id
        //     }).then(res => {
        //         if (res.data.result.code) {
        //             this.update()
        //         } else {
        //             if (this.users.code) {
        //                 this.$post('users/verify_code', {
        //                     code: this.users.code,
        //                     token: this.$store.state.id
        //                 })
        //                     .then(res => {
        //                         // console.log(res)
        //                         if (res.data.result) {
        //                             this.message = '该登录名已存在';
        //                             let model = document.querySelector('#modal-close-default-two');
        //                             UIkit.modal(model).show();
        //                         } else {
        //                             this.update()
        //                         }
        //                     })
        //             } else {
        //                 this.update()
        //             }
        //         }
        //     })

        // },
    },
    created() {
        this.getusers();
    },
    mounted() {
        document.title = '编辑个人信息';
    }



}
